import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SetStockList, GetStockList } from "../../store/stockAtom";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { stockService } from "../../services/stockService";

function StockViewScroll({ onSelection, viewItemDetails }) {
  const setStockData = SetStockList();
  const getStockData = GetStockList();
  const [tableData, setTableData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    if (getStockData?.stock_info?.length > 0) {
      setTableData(getStockData?.stock_info);
    } else {
      getStockListFromAPI();
    }
  }, [getStockData?.stock_info]);

  const getStockListFromAPI = useCallback(async () => {
    try {
      const response = await stockService.stockViewList();
      if (response?.data) {
        setStockData(response.data);
        setTableData(response.data?.stock_info || []);
      }
    } catch (err) {
      console.error(err);
    }
  }, [setStockData]);

  const stockItems = tableData.length > 0 ? tableData : getStockData?.stock_info || [];

  return (
    <section className="mt-4 border border-gray-200 rounded-lg bg-white shadow-sm overflow-hidden">
      {/* Full viewport height scrollable area */}
      <div className="max-h-[calc(100vh-40px)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent hover:scrollbar-thumb-gray-400">
        {stockItems.map((info, index) => (
          <div
            key={index}
            onClick={() => viewItemDetails(info?.item_id)}
            className={`flex items-center p-3 border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors duration-200 last:border-b-0 ${
              Number(id) == info?.item_id ? "bg-blue-50" : ""
            }`}
          >
            <div className="flex items-center space-x-3 w-full">
              <div className="flex-1">
                <div className="font-semibold text-gray-800 text-sm">{info?.item_name}</div>
                <div className="text-sm text-gray-500 italic">
                  Phy {formatCustomNumber(info?.physical_stock_quantity)}
                </div>
                <div className="text-sm text-gray-600">
                  Trans {formatCustomNumber(info?.purchase_transit_quantity)}
                </div>
                <div className="text-sm text-gray-600">
                  
                  Acc {formatCustomNumber(info?.accounting_quantity)}
                </div>
                <div className="text-sm text-gray-600">
                  
                  Acc {formatCustomNumber(info?.committed_order_quantity)}
                </div>
              </div>
            </div>
          </div>
        ))}


        {stockItems.length === 0 && (
          <div className="p-8 text-center text-gray-400 text-sm py-12">No stock items found</div>
        )}
      </div>
    </section>
  );
}

export default StockViewScroll;